import { render, staticRenderFns } from "./slimGroupElement.vue?vue&type=template&id=1d30bdb4&scoped=true"
import script from "./slimGroupElement.vue?vue&type=script&lang=js"
export * from "./slimGroupElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d30bdb4",
  null
  
)

export default component.exports